import { Heading, Text } from '@zillow/constellation';
import type { Answers } from '../../../../../graphql/queries';
import { getAnswersForFields } from '../../../../../utils/overview/overview-display';
import { FIELD_IDS } from '../../../../../constants/wizard';
import { getPhoneNumberScreenFormat } from '../../../../../utils/formatters';

interface Props {
  answers: Answers;
}

const fieldsInStep = [FIELD_IDS.PHONE, FIELD_IDS.EMAIL];

export function ContactOverview({ answers }: Props) {
  const answersForFields = getAnswersForFields({ fieldIds: fieldsInStep, answers });

  const formattedPhone = answersForFields[FIELD_IDS.PHONE]
    ? getPhoneNumberScreenFormat(answersForFields[FIELD_IDS.PHONE] as string)
    : null;

  return (
    <>
      {formattedPhone && (
        <>
          <Heading level={6} marginY="xs">
            Phone number
          </Heading>
          <Text>{formattedPhone}</Text>
        </>
      )}
      <Heading level={6} marginY="xs">
        Email
      </Heading>
      <Text>{answersForFields[FIELD_IDS.EMAIL]}</Text>
    </>
  );
}
